import React from "react";
import { Grid, FormControlLabel, Typography } from "@material-ui/core";
import {
  CancelledSwitch,
  DelayedSwitch,
  DoneSwitch,
  OnTimeSwitch,
} from "./customSwitches";
import { useDispatch, useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import { getSwitchBg, getSwitchColor } from "helpers/themeColors";
import { green, red, orange, blue } from "@mui/material/colors";
import { filtersItemsRequests } from "redux/actions/integrations/itemsRequestActions";

const style = {
  width: "100%",
  padding: "2px 8px",
  borderRadius: 4,
  marginLeft: 0,
  transition: "0.3s ease",
};
export const FilterSwitches = () => {
  const {
    temp: { IN_ORACLE, PARTIALLY_IN_ORACLE, REJECTED, PENDING },
    status,
  } = useSelector(({ itemsRequests }) => itemsRequests);
  const { isDark } = useThemeMode();
  const dispatch = useDispatch();

  const handleFilters = (e, field) => {
    dispatch(filtersItemsRequests(field));
  };

  return (
    <Grid container spacing={1} style={{ marginTop: 8 }}>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <OnTimeSwitch
              checked={status.IN_ORACLE}
              onClick={(e) => handleFilters(e, "IN_ORACLE")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(green, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {IN_ORACLE.length}
              </span>
              - En Oracle
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(green, isDark),
            backgroundColor: getSwitchBg(green, status.IN_ORACLE, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <DelayedSwitch
              checked={status.PARTIALLY_IN_ORACLE}
              onClick={(e) => handleFilters(e, "PARTIALLY_IN_ORACLE")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(orange, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {PARTIALLY_IN_ORACLE.length} 
              </span>
              - Incompleto
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(orange, isDark),
            backgroundColor: getSwitchBg(orange, status.PARTIALLY_IN_ORACLE, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <CancelledSwitch
              checked={status.REJECTED}
              onClick={(e) => handleFilters(e, "REJECTED")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(red, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {REJECTED.length} 
              </span>
              - Rechazados
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(red, isDark),
            backgroundColor: getSwitchBg(red, status.REJECTED, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <DoneSwitch
              checked={status.PENDING}
              onClick={(e) => handleFilters(e, "PENDING")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(blue, isDark),
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: 20
                }}
              >
                {PENDING.length} 
              </span>
              - Sin Iniciar
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(blue, isDark),
            backgroundColor: getSwitchBg(blue, status.PENDING, isDark),
          }}
        />
      </Grid>
    </Grid>
  );
};
